import React from 'react';
import { Modal } from 'react-bootstrap';
import { Card, Button } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';

const DeletePaymentMethodModal = ({ _this }) => {
  return (
    <Modal
      style={{ zIndex: 9999 }}
      show={_this.deletePaymentMethodModalOpen}
      onHide={() => _this.setDeletePaymentMethodModalOpen(false)}
      // fullscreen="lg-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Alert</Modal.Title>
        <AiFillCloseCircle size={30} onClick={() => _this.setDeletePaymentMethodModalOpen(false)} />
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-3 flex  mr-2">
          <h3 className="text-font-label text-lg">
            Are You sure you want to delete{' '}
            <span className="text-black">
              XXXX XXXX XXXX {_this.deletePaymentMethodData?.last_4_digit}
            </span>{' '}
            this payment method.
          </h3>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button color="danger" onClick={() => _this.handleDeletePaymentMethod()}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePaymentMethodModal;
